import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import {useDispatch, useSelector} from 'react-redux'
import * as Actions from 'state/actions'

import { getSelectedInteraction, isChatEnabled } from 'state/selectors'

const Input = styled.textarea`
  width: 80%;
  height: 22px;
  min-height: 22px;
  max-height: 100px;
  overflow-y:hidden;
  border: none;
  background: inherit;
  font-size: 14rem;
  color: #424761;
  caret-color: #90A1B0;
  line-height: 18rem;
  resize: none;
  padding: 2px;
`


const ComposeInput = (props) => {
  const { setMessage, message } = props
  const [isCooldown, setCooldown] = useState(false)

  const dispatch = useDispatch()
  const { assigned } = useSelector(getSelectedInteraction)
  const isEnabled = useSelector(isChatEnabled)


  const handleMessage = (e) => {
    if (message.trim() && e.key === 'Enter' && !e.shiftKey && isEnabled) {
      if(!assigned) dispatch(Actions.assignInteraction())
      dispatch(Actions.sendMessage(message))
      setMessage('')
    }
  }
  const autoGrow = (e) => {
    const element = e.target
    if (element.scrollHeight > 27) {
      element.style.height = '5px'
      element.style.height = (element.scrollHeight+5)+'px'
    }
  }

  const handleChange = (e) => {
    setMessage(e.target.value)
    if(!isCooldown) {
      setCooldown(true)
      setTimeout(() => setCooldown(false), 5000)
      dispatch(Actions.sendActivityStart())
    }
  }

  return (
    <Input
      cols="60"
      wrap="hard"
      value = {message}
      onKeyDown ={handleMessage}
      onChange = {handleChange}
      onInput = {autoGrow}
    />
  )
}
ComposeInput.propTypes = {
  setMessage: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired
}

export default ComposeInput
